import { observeElement } from '@uvocore-front/utils';

import '../../theme/DefaultTheme';
import Tabs from '../../components/Tabs';
import '../../components/TestomonialsSlider';

/* eslint-disable */
if (document.querySelector('.services__tabs')) {
  observeElement({
    element: '.services__tabs',
    marginValue: 200,
    callback: () => {
      new Tabs(document.querySelector('.services__tabs'));
    },
  });
}
